import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { motion } from 'framer-motion';
import { forwardRef } from 'react';
import { brand } from '@iheart/shared';
import { cn } from './cn.js';
const sizeClasses = {
    sm: 'h-8 px-3 text-sm rounded-md',
    md: 'h-10 px-4 text-sm rounded-lg',
    lg: 'h-12 px-6 text-base rounded-xl',
};
const variantClasses = {
    primary: 'text-white shadow-sm hover:shadow-md focus-visible:ring-2 focus-visible:ring-pink-300',
    secondary: 'bg-white text-body border border-neutral-200 hover:border-neutral-300 focus-visible:ring-2 focus-visible:ring-neutral-300',
    ghost: 'bg-transparent text-body hover:bg-neutral-100',
    danger: 'bg-danger text-white hover:bg-red-600 focus-visible:ring-2 focus-visible:ring-red-300',
};
/**
 * Branded primary button. Grows by `motion.grow` (≈5px on a 100px button)
 * via `transform: scale` so it never causes layout shift inside grids.
 *
 * Always render via this component (never a raw `<button>` for CTAs) so the
 * brand motion + gradient stay consistent across the whole app.
 */
export const MotionButton = forwardRef(function MotionButton({ variant = 'primary', size = 'md', loading, className, children, style, disabled, ...rest }, ref) {
    const isPrimary = variant === 'primary';
    return (_jsxs(motion.button, { ref: ref, disabled: disabled ?? loading, whileHover: disabled || loading ? undefined : { scale: brand.motion.grow }, whileTap: disabled || loading ? undefined : { scale: brand.motion.grow }, transition: brand.motion.spring, style: {
            ...(isPrimary ? { backgroundImage: brand.gradient.primary } : {}),
            ...style,
        }, className: cn('inline-flex items-center justify-center gap-2 font-medium transition-shadow', 'disabled:cursor-not-allowed disabled:opacity-60', 'focus:outline-none', sizeClasses[size], variantClasses[variant], className), ...rest, children: [loading ? _jsx("span", { className: "inline-block size-4 animate-spin rounded-full border-2 border-current border-r-transparent" }) : null, children] }));
});
//# sourceMappingURL=MotionButton.js.map